module.exports = __webpack_public_path__ + "static/media/tab4.20de039e.svg";